import { render, staticRenderFns } from "./ProductCallToAction.vue?vue&type=template&id=20debdf3&scoped=true"
import script from "./ProductCallToAction.vue?vue&type=script&lang=ts"
export * from "./ProductCallToAction.vue?vue&type=script&lang=ts"
import style0 from "./ProductCallToAction.vue?vue&type=style&index=0&id=20debdf3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20debdf3",
  null
  
)

export default component.exports